export enum MarginTypeEnum {
  CROSSED = 'CROSSED',
  ISOLATED = 'ISOLATED',
}
